import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';

const viloyatMenu = [
  { id: '/', label: 'Dashboard', icon: 'home' },
  { id: '/users', label: 'Tuman/Shaharlar', icon: 'building' },
  { id: '/youth', label: 'Yoshlar reestri', icon: 'clipboardList' },
  { id: '/problems', label: 'Muammolar', icon: 'alertTriangle' },
  { id: '/migrants', label: 'Migrantlar', icon: 'plane' },
  { id: '/events', label: 'Tadbirlar', icon: 'flag' },
  { id: '/hokim', label: 'Hokimga savol', icon: 'messageSquare' },
  { id: '/ai', label: "Sun'iy intellekt", icon: 'brain' },
];

const tumanMenu = [
  { id: '/', label: 'Dashboard', icon: 'home' },
  { id: '/mfy', label: 'MFY yettiligi', icon: 'users' },
  { id: '/youth', label: 'Yoshlar reestri', icon: 'clipboardList' },
  { id: '/problems', label: 'Muammolar', icon: 'alertTriangle' },
  { id: '/migrants', label: 'Migrantlar', icon: 'plane' },
  { id: '/events', label: 'Tadbirlar', icon: 'flag' },
  { id: '/hokim', label: 'Hokimga savol', icon: 'messageSquare' },
  { id: '/ai', label: "Sun'iy intellekt", icon: 'brain' },
];

const mfyMenu = [
  { id: '/', label: 'Dashboard', icon: 'home' },
  { id: '/youth', label: 'Yoshlar reestri', icon: 'clipboardList' },
  { id: '/problems', label: 'Muammolar', icon: 'alertTriangle' },
  { id: '/migrants', label: 'Migrantlar', icon: 'plane' },
  { id: '/events', label: 'Tadbirlar', icon: 'flag' },
  { id: '/hokim', label: 'Hokimga savol', icon: 'messageSquare' },
  { id: '/ai', label: "Sun'iy intellekt", icon: 'brain' },
];

export default function Sidebar({ user, onLogout, onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const menu = user?.role === 'mfy' ? mfyMenu : user?.role === 'tuman_admin' ? tumanMenu : viloyatMenu;

  const handleNav = (path) => {
    navigate(path);
    if (onNavigate) onNavigate();
  };

  return (
    <div style={{
      width: 280, height: '100%', background: '#fff',
      borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column', flexShrink: 0, overflowY: 'auto',
    }}>
      {/* Gradient branding card */}
      <div style={{ padding: '20px 16px 0' }}>
        <div style={{
          padding: '22px 20px', borderRadius: 18,
          background: 'linear-gradient(135deg, var(--accent), var(--violet))',
          marginBottom: 8,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              width: 46, height: 46, borderRadius: 14,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            }}>
              <Icon name="shield" size={24} />
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', letterSpacing: '-0.01em' }}>YOSHLAR</div>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#c7d2fe', letterSpacing: '0.12em' }}>
                {user?.role === 'mfy' ? 'MFY PANEL' : user?.role === 'tuman_admin' ? 'TUMAN PANEL' : 'ADMIN PANEL'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Menu label */}
      <div style={{ padding: '18px 22px 8px', fontSize: 10, fontWeight: 700, color: 'var(--text-dim)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>
        Asosiy menu
      </div>

      {/* Menu items */}
      <nav style={{ flex: 1, padding: '0 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
        {menu.map(m => {
          const active = location.pathname === m.id;
          return (
            <button key={m.id} onClick={() => handleNav(m.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '13px 16px', borderRadius: 14, border: 'none',
                cursor: 'pointer', fontFamily: 'inherit',
                background: active ? 'var(--accent-light)' : 'transparent',
                color: active ? 'var(--accent-dark)' : '#475569',
                fontSize: 15, fontWeight: active ? 700 : 500,
                textAlign: 'left', width: '100%',
                transition: 'all .15s', position: 'relative',
              }}
              onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#f8fafc'; }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
            >
              {active && (
                <div style={{
                  position: 'absolute', left: 0, top: '18%', bottom: '18%',
                  width: 4, borderRadius: 2, background: 'var(--accent)',
                }} />
              )}
              <div style={{
                width: 38, height: 38, borderRadius: 11,
                background: active ? 'var(--accent)' : '#f1f5f9',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all .15s', flexShrink: 0,
              }}>
                <Icon name={m.icon} size={20} color={active ? '#fff' : '#64748b'} />
              </div>
              {m.label}
            </button>
          );
        })}
      </nav>

      <div style={{ padding: '14px' }} />
    </div>
  );
}
